import { render, staticRenderFns } from "./PageSupportPanel.vue?vue&type=template&id=8984e616&"
import script from "./PageSupportPanel.vue?vue&type=script&lang=js&"
export * from "./PageSupportPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports